import { createContext } from 'react';

const ProductPreviewContext = createContext();

export default ProductPreviewContext;
